const PMTILES_URL = `/api/map/proto-tiles`;
const baseStyleRaw = {
    version: 8,
    sources: {
        protomaps: {
            type: 'vector',
            url: 'pmtiles://' + PMTILES_URL,
            attribution: '© <a href="https://openstreetmap.org">OpenStreetMap</a>',
        },
        // osm: {
        //   type: 'raster',
        //   tiles: ['https://wms.openstreetmap.fr/tms/1.0.0/tous_fr/{z}/{x}/{y}'],
        //   tileSize: 256,
        //   attribution:
        //     'Map tiles by <a target="_blank" href="https://stamen.com">Stamen Design</a>; Hosting by <a href="https://stadiamaps.com/" target="_blank">Stadia Maps</a>. Data &copy; <a href="https://www.openstreetmap.org/about" target="_blank">OpenStreetMap</a> contributors',
        // },
    },
    layers: [
        // {
        //   id: 'simple-tiles',
        //   type: 'raster',
        //   source: 'osm',
        //   minzoom: 0,
        //   maxzoom: 22,
        // },
        {
            id: 'background',
            type: 'background',
            paint: {
                'background-color': '#cccccc',
            },
        },
        {
            'id': 'earth',
            'type': 'fill',
            'source': 'protomaps',
            'source-layer': 'earth',
            'paint': {
                'fill-color': '#e0e0e0',
            },
        },
        {
            'id': 'landuse_park',
            'type': 'fill',
            'source': 'protomaps',
            'source-layer': 'landuse',
            'filter': [
                'any',
                [
                    'in',
                    'pmap:kind',
                    'national_park',
                    'park',
                    'cemetery',
                    'protected_area',
                    'nature_reserve',
                    'forest',
                    'golf_course',
                ],
            ],
            'paint': {
                'fill-color': [
                    'interpolate',
                    ['linear'],
                    ['zoom'],
                    0,
                    '#cfddd5',
                    12,
                    '#9cd3b4',
                ],
            },
        },
        {
            'id': 'landuse_urban_green',
            'type': 'fill',
            'source': 'protomaps',
            'source-layer': 'landuse',
            'filter': [
                'any',
                [
                    'in',
                    'pmap:kind',
                    'allotments',
                    'village_green',
                    'playground',
                ],
            ],
            'paint': {
                'fill-color': '#9cd3b4',
                'fill-opacity': 0.7,
            },
        },
        {
            'id': 'landuse_hospital',
            'type': 'fill',
            'source': 'protomaps',
            'source-layer': 'landuse',
            'filter': ['any', ['==', 'pmap:kind', 'hospital']],
            'paint': {
                'fill-color': '#e4dad9',
            },
        },
        {
            'id': 'landuse_industrial',
            'type': 'fill',
            'source': 'protomaps',
            'source-layer': 'landuse',
            'filter': ['any', ['==', 'pmap:kind', 'industrial']],
            'paint': {
                'fill-color': '#d1dde1',
            },
        },
        {
            'id': 'landuse_school',
            'type': 'fill',
            'source': 'protomaps',
            'source-layer': 'landuse',
            'filter': [
                'any',
                ['in', 'pmap:kind', 'school', 'university', 'college'],
            ],
            'paint': {
                'fill-color': '#e4ded7',
            },
        },
        {
            'id': 'landuse_beach',
            'type': 'fill',
            'source': 'protomaps',
            'source-layer': 'landuse',
            'filter': ['any', ['in', 'pmap:kind', 'beach']],
            'paint': {
                'fill-color': '#e8e4d0',
            },
        },
        {
            'id': 'landuse_zoo',
            'type': 'fill',
            'source': 'protomaps',
            'source-layer': 'landuse',
            'filter': ['any', ['in', 'pmap:kind', 'zoo']],
            'paint': {
                'fill-color': '#c6dcdc',
            },
        },
        {
            'id': 'landuse_military',
            'type': 'fill',
            'source': 'protomaps',
            'source-layer': 'landuse',
            'filter': [
                'any',
                ['in', 'pmap:kind', 'military', 'naval_base', 'airfield'],
            ],
            'paint': {
                'fill-color': '#c6dcdc',
            },
        },
        {
            'id': 'natural_wood',
            'type': 'fill',
            'source': 'protomaps',
            'source-layer': 'natural',
            'filter': [
                'any',
                ['in', 'pmap:kind', 'wood', 'nature_reserve', 'forest'],
            ],
            'paint': {
                'fill-color': [
                    'interpolate',
                    ['linear'],
                    ['zoom'],
                    0,
                    '#d0ded0',
                    12,
                    '#a0d9a0',
                ],
            },
        },
        {
            'id': 'natural_scrub',
            'type': 'fill',
            'source': 'protomaps',
            'source-layer': 'natural',
            'filter': ['in', 'pmap:kind', 'scrub', 'grassland', 'grass'],
            'paint': {
                'fill-color': [
                    'interpolate',
                    ['linear'],
                    ['zoom'],
                    0,
                    '#cedcd7',
                    12,
                    '#99d2bb',
                ],
            },
        },
        {
            'id': 'natural_glacier',
            'type': 'fill',
            'source': 'protomaps',
            'source-layer': 'natural',
            'filter': ['==', 'pmap:kind', 'glacier'],
            'paint': {
                'fill-color': '#e7e7e7',
            },
        },
        {
            'id': 'natural_sand',
            'type': 'fill',
            'source': 'protomaps',
            'source-layer': 'natural',
            'filter': ['==', 'pmap:kind', 'sand'],
            'paint': {
                'fill-color': '#e2e0d7',
            },
        },
        {
            'id': 'landuse_aerodrome',
            'type': 'fill',
            'source': 'protomaps',
            'source-layer': 'landuse',
            'filter': ['any', ['in', 'pmap:kind', 'aerodrome']],
            'paint': {
                'fill-color': '#dadbdf',
            },
        },
        {
            'id': 'transit_runway',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'transit',
            'filter': ['any', ['in', 'pmap:kind_detail', 'runway']],
            'paint': {
                'line-color': '#e9e9ed',
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    10,
                    0,
                    12,
                    4,
                    18,
                    30,
                ],
            },
        },
        {
            'id': 'transit_taxiway',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'transit',
            'minzoom': 13,
            'filter': ['any', ['in', 'pmap:kind_detail', 'taxiway']],
            'paint': {
                'line-color': '#e9e9ed',
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    13,
                    0,
                    13.5,
                    1,
                    15,
                    6,
                ],
            },
        },
        {
            'id': 'water',
            'type': 'fill',
            'source': 'protomaps',
            'source-layer': 'water',
            'paint': {
                'fill-color': '#80deea',
            },
        },
        {
            'id': 'physical_line_stream',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'physical_line',
            'minzoom': 14,
            'filter': ['all', ['in', 'pmap:kind', 'stream']],
            'paint': {
                'line-color': '#80deea',
                'line-width': 0.5,
            },
        },
        {
            'id': 'physical_line_river',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'physical_line',
            'minzoom': 9,
            'filter': ['all', ['in', 'pmap:kind', 'river']],
            'paint': {
                'line-color': '#80deea',
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    9,
                    0,
                    9.5,
                    1,
                    18,
                    12,
                ],
            },
        },
        {
            'id': 'landuse_pedestrian',
            'type': 'fill',
            'source': 'protomaps',
            'source-layer': 'landuse',
            'filter': ['any', ['==', 'pmap:kind', 'pedestrian']],
            'paint': {
                'fill-color': '#e3e0d4',
            },
        },
        {
            'id': 'landuse_pier',
            'type': 'fill',
            'source': 'protomaps',
            'source-layer': 'landuse',
            'filter': ['any', ['==', 'pmap:kind', 'pier']],
            'paint': {
                'fill-color': '#e0e0e0',
            },
        },
        {
            'id': 'roads_tunnels_other_casing',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'filter': [
                'all',
                ['<', 'pmap:level', 0],
                ['in', 'pmap:kind', 'other', 'path'],
            ],
            'paint': {
                'line-color': '#e0e0e0',
                'line-gap-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    14,
                    0,
                    20,
                    7,
                ],
            },
        },
        {
            'id': 'roads_tunnels_minor_casing',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'filter': [
                'all',
                ['<', 'pmap:level', 0],
                ['==', 'pmap:kind', 'minor_road'],
            ],
            'paint': {
                'line-color': '#e0e0e0',
                'line-dasharray': [3, 2],
                'line-gap-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    11,
                    0,
                    12.5,
                    0.5,
                    15,
                    2,
                    18,
                    11,
                ],
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    12,
                    0,
                    12.5,
                    1,
                ],
            },
        },
        {
            'id': 'roads_tunnels_link_casing',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'filter': ['all', ['<', 'pmap:level', 0], ['==', 'pmap:link', 1]],
            'paint': {
                'line-color': '#e0e0e0',
                'line-dasharray': [3, 2],
                'line-gap-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    13,
                    0,
                    13.5,
                    1,
                    18,
                    11,
                ],
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    12,
                    0,
                    12.5,
                    1,
                ],
            },
        },
        {
            'id': 'roads_tunnels_medium_casing',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'filter': [
                'all',
                ['<', 'pmap:level', 0],
                ['==', 'pmap:kind', 'medium_road'],
            ],
            'paint': {
                'line-color': '#e0e0e0',
                'line-dasharray': [3, 2],
                'line-gap-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    7,
                    0,
                    7.5,
                    0.5,
                    18,
                    13,
                ],
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    10,
                    0,
                    10.5,
                    1,
                ],
            },
        },
        {
            'id': 'roads_tunnels_major_casing',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'filter': [
                'all',
                ['<', 'pmap:level', 0],
                ['==', 'pmap:kind', 'major_road'],
            ],
            'paint': {
                'line-color': '#e0e0e0',
                'line-dasharray': [3, 2],
                'line-gap-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    7,
                    0,
                    7.5,
                    0.5,
                    18,
                    13,
                ],
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    9,
                    0,
                    9.5,
                    1,
                ],
            },
        },
        {
            'id': 'roads_tunnels_highway_casing',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'filter': [
                'all',
                ['<', 'pmap:level', 0],
                ['==', 'pmap:kind', 'highway'],
                ['!=', 'pmap:link', 1],
            ],
            'paint': {
                'line-color': '#e0e0e0',
                'line-dasharray': [6, 0.5],
                'line-gap-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    3,
                    0,
                    3.5,
                    0.5,
                    18,
                    15,
                ],
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    7,
                    0,
                    7.5,
                    1,
                    20,
                    15,
                ],
            },
        },
        {
            'id': 'roads_tunnels_other',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'filter': [
                'all',
                ['<', 'pmap:level', 0],
                ['in', 'pmap:kind', 'other', 'path'],
            ],
            'paint': {
                'line-color': '#d5d5d5',
                'line-dasharray': [4.5, 0.5],
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    14,
                    0,
                    20,
                    7,
                ],
            },
        },
        {
            'id': 'roads_tunnels_minor',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'filter': [
                'all',
                ['<', 'pmap:level', 0],
                ['==', 'pmap:kind', 'minor_road'],
            ],
            'paint': {
                'line-color': '#d5d5d5',
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    11,
                    0,
                    12.5,
                    0.5,
                    15,
                    2,
                    18,
                    11,
                ],
            },
        },
        {
            'id': 'roads_tunnels_link',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'filter': ['all', ['<', 'pmap:level', 0], ['==', 'pmap:link', 1]],
            'paint': {
                'line-color': '#d5d5d5',
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    13,
                    0,
                    13.5,
                    1,
                    18,
                    11,
                ],
            },
        },
        {
            'id': 'roads_tunnels_medium',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'filter': [
                'all',
                ['<', 'pmap:level', 0],
                ['==', 'pmap:kind', 'medium_road'],
            ],
            'paint': {
                'line-color': '#d5d5d5',
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    7,
                    0,
                    12,
                    1.2,
                    15,
                    3,
                    18,
                    13,
                ],
            },
        },
        {
            'id': 'roads_tunnels_major',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'filter': [
                'all',
                ['<', 'pmap:level', 0],
                ['==', 'pmap:kind', 'major_road'],
            ],
            'paint': {
                'line-color': '#d5d5d5',
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    6,
                    0,
                    12,
                    1.6,
                    15,
                    3,
                    18,
                    13,
                ],
            },
        },
        {
            'id': 'roads_tunnels_highway',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'filter': [
                'all',
                ['<', 'pmap:level', 0],
                ['==', 'pmap:kind', 'highway'],
                ['!=', 'pmap:link', 1],
            ],
            'paint': {
                'line-color': '#d5d5d5',
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    3,
                    0,
                    6,
                    1.1,
                    12,
                    1.6,
                    15,
                    5,
                    18,
                    15,
                ],
            },
        },
        {
            'id': 'transit_pier',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'transit',
            'filter': ['any', ['==', 'pmap:kind', 'pier']],
            'paint': {
                'line-color': '#e0e0e0',
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    12,
                    0,
                    12.5,
                    0.5,
                    20,
                    16,
                ],
            },
        },
        {
            'id': 'roads_minor_service_casing',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'minzoom': 13,
            'filter': [
                'all',
                ['==', 'pmap:level', 0],
                ['==', 'pmap:kind', 'minor_road'],
                ['==', 'pmap:kind_detail', 'service'],
            ],
            'paint': {
                'line-color': '#e0e0e0',
                'line-gap-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    13,
                    0,
                    18,
                    8,
                ],
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    13,
                    0,
                    13.5,
                    0.8,
                ],
            },
        },
        {
            'id': 'roads_minor_casing',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'filter': [
                'all',
                ['==', 'pmap:level', 0],
                ['==', 'pmap:kind', 'minor_road'],
                ['!=', 'pmap:kind_detail', 'service'],
            ],
            'paint': {
                'line-color': '#e0e0e0',
                'line-gap-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    11,
                    0,
                    12.5,
                    0.5,
                    15,
                    2,
                    18,
                    11,
                ],
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    12,
                    0,
                    12.5,
                    1,
                ],
            },
        },
        {
            'id': 'roads_link_casing',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'minzoom': 13,
            'filter': ['all', ['==', 'pmap:link', 1]],
            'paint': {
                'line-color': '#e0e0e0',
                'line-gap-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    13,
                    0,
                    13.5,
                    1,
                    18,
                    11,
                ],
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    13,
                    0,
                    13.5,
                    1.5,
                ],
            },
        },
        {
            'id': 'roads_medium_casing',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'filter': [
                'all',
                ['==', 'pmap:level', 0],
                ['==', 'pmap:kind', 'medium_road'],
            ],
            'paint': {
                'line-color': '#e0e0e0',
                'line-gap-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    7,
                    0,
                    12,
                    1.2,
                    15,
                    3,
                    18,
                    13,
                ],
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    10,
                    0,
                    10.5,
                    1.5,
                ],
            },
        },
        {
            'id': 'roads_major_casing_late',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'minzoom': 12,
            'filter': [
                'all',
                ['==', 'pmap:level', 0],
                ['==', 'pmap:kind', 'major_road'],
            ],
            'paint': {
                'line-color': '#e0e0e0',
                'line-gap-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    6,
                    0,
                    12,
                    1.6,
                    15,
                    3,
                    18,
                    13,
                ],
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    9,
                    0,
                    9.5,
                    1,
                ],
            },
        },
        {
            'id': 'roads_highway_casing_late',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'minzoom': 12,
            'filter': [
                'all',
                ['==', 'pmap:level', 0],
                ['==', 'pmap:kind', 'highway'],
                ['!=', 'pmap:link', 1],
            ],
            'paint': {
                'line-color': '#e0e0e0',
                'line-gap-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    3,
                    0,
                    3.5,
                    0.5,
                    18,
                    15,
                ],
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    7,
                    0,
                    7.5,
                    1,
                    20,
                    15,
                ],
            },
        },
        {
            'id': 'roads_other',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'filter': [
                'all',
                ['==', 'pmap:level', 0],
                ['in', 'pmap:kind', 'other', 'path'],
            ],
            'paint': {
                'line-color': '#ebebeb',
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    14,
                    0,
                    20,
                    7,
                ],
            },
        },
        {
            'id': 'roads_link',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'filter': ['all', ['==', 'pmap:link', 1]],
            'paint': {
                'line-color': '#ffffff',
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    13,
                    0,
                    13.5,
                    1,
                    18,
                    11,
                ],
            },
        },
        {
            'id': 'roads_minor_service',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'filter': [
                'all',
                ['==', 'pmap:level', 0],
                ['==', 'pmap:kind', 'minor_road'],
                ['==', 'pmap:kind_detail', 'service'],
            ],
            'paint': {
                'line-color': '#ebebeb',
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    13,
                    0,
                    18,
                    8,
                ],
            },
        },
        {
            'id': 'roads_minor',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'filter': [
                'all',
                ['==', 'pmap:level', 0],
                ['==', 'pmap:kind', 'minor_road'],
                ['!=', 'pmap:kind_detail', 'service'],
            ],
            'paint': {
                'line-color': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    11,
                    '#ebebeb',
                    16,
                    '#ffffff',
                ],
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    11,
                    0,
                    12.5,
                    0.5,
                    15,
                    2,
                    18,
                    11,
                ],
            },
        },
        {
            'id': 'roads_medium',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'filter': [
                'all',
                ['==', 'pmap:level', 0],
                ['==', 'pmap:kind', 'medium_road'],
            ],
            'paint': {
                'line-color': '#f5f5f5',
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    7,
                    0,
                    12,
                    1.2,
                    15,
                    3,
                    18,
                    13,
                ],
            },
        },
        {
            'id': 'roads_major_casing_early',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'maxzoom': 12,
            'filter': [
                'all',
                ['==', 'pmap:level', 0],
                ['==', 'pmap:kind', 'major_road'],
            ],
            'paint': {
                'line-color': '#e0e0e0',
                'line-gap-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    7,
                    0,
                    7.5,
                    0.5,
                    18,
                    13,
                ],
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    9,
                    0,
                    9.5,
                    1,
                ],
            },
        },
        {
            'id': 'roads_major',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'filter': [
                'all',
                ['==', 'pmap:level', 0],
                ['==', 'pmap:kind', 'major_road'],
            ],
            'paint': {
                'line-color': '#ffffff',
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    6,
                    0,
                    12,
                    1.6,
                    15,
                    3,
                    18,
                    13,
                ],
            },
        },
        {
            'id': 'roads_highway_casing_early',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'maxzoom': 12,
            'filter': [
                'all',
                ['==', 'pmap:level', 0],
                ['==', 'pmap:kind', 'highway'],
                ['!=', 'pmap:link', 1],
            ],
            'paint': {
                'line-color': '#e0e0e0',
                'line-gap-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    3,
                    0,
                    3.5,
                    0.5,
                    18,
                    15,
                ],
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    7,
                    0,
                    7.5,
                    1,
                ],
            },
        },
        {
            'id': 'roads_highway',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'filter': [
                'all',
                ['==', 'pmap:level', 0],
                ['==', 'pmap:kind', 'highway'],
                ['!=', 'pmap:link', 1],
            ],
            'paint': {
                'line-color': '#ffffff',
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    3,
                    0,
                    6,
                    1.1,
                    12,
                    1.6,
                    15,
                    5,
                    18,
                    15,
                ],
            },
        },
        {
            'id': 'transit_railway',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'transit',
            'filter': ['all', ['==', 'pmap:kind', 'rail']],
            'paint': {
                'line-dasharray': [0.3, 0.75],
                'line-opacity': 0.5,
                'line-color': '#a7b1b3',
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    3,
                    0,
                    6,
                    0.15,
                    18,
                    9,
                ],
            },
        },
        {
            'id': 'boundaries_country',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'boundaries',
            'filter': ['<=', 'pmap:min_admin_level', 2],
            'paint': {
                'line-color': '#adadad',
                'line-width': 1,
                'line-dasharray': [3, 2],
            },
        },
        {
            'id': 'boundaries',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'boundaries',
            'filter': ['>', 'pmap:min_admin_level', 2],
            'paint': {
                'line-color': '#adadad',
                'line-width': 0.5,
                'line-dasharray': [3, 2],
            },
        },
        {
            'id': 'roads_bridges_other_casing',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'minzoom': 12,
            'filter': [
                'all',
                ['>', 'pmap:level', 0],
                ['in', 'pmap:kind', 'other', 'path'],
            ],
            'paint': {
                'line-color': '#e0e0e0',
                'line-gap-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    14,
                    0,
                    20,
                    7,
                ],
            },
        },
        {
            'id': 'roads_bridges_link_casing',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'minzoom': 12,
            'filter': ['all', ['>', 'pmap:level', 0], ['==', 'pmap:link', 1]],
            'paint': {
                'line-color': '#e0e0e0',
                'line-gap-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    13,
                    0,
                    13.5,
                    1,
                    18,
                    11,
                ],
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    12,
                    0,
                    12.5,
                    1.5,
                ],
            },
        },
        {
            'id': 'roads_bridges_minor_casing',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'minzoom': 12,
            'filter': [
                'all',
                ['>', 'pmap:level', 0],
                ['==', 'pmap:kind', 'minor_road'],
            ],
            'paint': {
                'line-color': '#e0e0e0',
                'line-gap-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    11,
                    0,
                    12.5,
                    0.5,
                    15,
                    2,
                    18,
                    11,
                ],
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    13,
                    0,
                    13.5,
                    0.8,
                ],
            },
        },
        {
            'id': 'roads_bridges_medium_casing',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'minzoom': 12,
            'filter': [
                'all',
                ['>', 'pmap:level', 0],
                ['==', 'pmap:kind', 'medium_road'],
            ],
            'paint': {
                'line-color': '#e0e0e0',
                'line-gap-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    7,
                    0,
                    12,
                    1.2,
                    15,
                    3,
                    18,
                    13,
                ],
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    10,
                    0,
                    10.5,
                    1.5,
                ],
            },
        },
        {
            'id': 'roads_bridges_major_casing',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'minzoom': 12,
            'filter': [
                'all',
                ['>', 'pmap:level', 0],
                ['==', 'pmap:kind', 'major_road'],
            ],
            'paint': {
                'line-color': '#e0e0e0',
                'line-gap-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    7,
                    0,
                    7.5,
                    0.5,
                    18,
                    10,
                ],
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    9,
                    0,
                    9.5,
                    1.5,
                ],
            },
        },
        {
            'id': 'roads_bridges_other',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'minzoom': 12,
            'filter': [
                'all',
                ['>', 'pmap:level', 0],
                ['in', 'pmap:kind', 'other', 'path'],
            ],
            'paint': {
                'line-color': '#ebebeb',
                'line-dasharray': [2, 1],
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    14,
                    0,
                    20,
                    7,
                ],
            },
        },
        {
            'id': 'roads_bridges_minor',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'minzoom': 12,
            'filter': [
                'all',
                ['>', 'pmap:level', 0],
                ['==', 'pmap:kind', 'minor_road'],
            ],
            'paint': {
                'line-color': '#ffffff',
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    11,
                    0,
                    12.5,
                    0.5,
                    15,
                    2,
                    18,
                    11,
                ],
            },
        },
        {
            'id': 'roads_bridges_link',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'minzoom': 12,
            'filter': ['all', ['>', 'pmap:level', 0], ['==', 'pmap:link', 1]],
            'paint': {
                'line-color': '#ffffff',
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    13,
                    0,
                    13.5,
                    1,
                    18,
                    11,
                ],
            },
        },
        {
            'id': 'roads_bridges_medium',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'minzoom': 12,
            'filter': [
                'all',
                ['>', 'pmap:level', 0],
                ['==', 'pmap:kind', 'medium_road'],
            ],
            'paint': {
                'line-color': '#f0eded',
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    7,
                    0,
                    12,
                    1.2,
                    15,
                    3,
                    18,
                    13,
                ],
            },
        },
        {
            'id': 'roads_bridges_major',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'minzoom': 12,
            'filter': [
                'all',
                ['>', 'pmap:level', 0],
                ['==', 'pmap:kind', 'major_road'],
            ],
            'paint': {
                'line-color': '#f5f5f5',
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    6,
                    0,
                    12,
                    1.6,
                    15,
                    3,
                    18,
                    13,
                ],
            },
        },
        {
            'id': 'roads_bridges_highway_casing',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'minzoom': 12,
            'filter': [
                'all',
                ['>', 'pmap:level', 0],
                ['==', 'pmap:kind', 'highway'],
                ['!=', 'pmap:link', 1],
            ],
            'paint': {
                'line-color': '#e0e0e0',
                'line-gap-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    3,
                    0,
                    3.5,
                    0.5,
                    18,
                    15,
                ],
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    7,
                    0,
                    7.5,
                    1,
                    20,
                    15,
                ],
            },
        },
        {
            'id': 'roads_bridges_highway',
            'type': 'line',
            'source': 'protomaps',
            'source-layer': 'roads',
            'filter': [
                'all',
                ['>', 'pmap:level', 0],
                ['==', 'pmap:kind', 'highway'],
                ['!=', 'pmap:link', 1],
            ],
            'paint': {
                'line-color': '#ffffff',
                'line-width': [
                    'interpolate',
                    ['exponential', 1.6],
                    ['zoom'],
                    3,
                    0,
                    6,
                    1.1,
                    12,
                    1.6,
                    15,
                    5,
                    18,
                    15,
                ],
            },
        },
        {
            'id': 'physical_line_waterway_label',
            'type': 'symbol',
            'source': 'protomaps',
            'source-layer': 'physical_line',
            'minzoom': 13,
            'filter': ['all', ['in', 'pmap:kind', 'river', 'stream']],
            'layout': {
                'symbol-placement': 'line',
                'text-font': ['Noto Sans Regular'],
                'text-field': ['get', 'name'],
                'text-size': 12,
                'text-letter-spacing': 0.3,
            },
            'paint': {
                'text-color': '#ffffff',
            },
        },
        {
            'id': 'physical_point_peak',
            'type': 'symbol',
            'source': 'protomaps',
            'source-layer': 'physical_point',
            'filter': ['any', ['==', 'pmap:kind', 'peak']],
            'layout': {
                'text-font': ['Noto Sans Italic'],
                'text-field': ['get', 'name'],
                'text-size': [
                    'interpolate',
                    ['linear'],
                    ['zoom'],
                    10,
                    8,
                    16,
                    12,
                ],
                'text-letter-spacing': 0.1,
                'text-max-width': 9,
            },
            'paint': {
                'text-color': '#7e9aa0',
                'text-halo-width': 1.5,
            },
        },
        {
            'id': 'roads_labels_minor',
            'type': 'symbol',
            'source': 'protomaps',
            'source-layer': 'roads',
            'minzoom': 15,
            'filter': [
                'any',
                ['in', 'pmap:kind', 'minor_road', 'other', 'path'],
            ],
            'layout': {
                'symbol-sort-key': ['get', 'pmap:min_zoom'],
                'symbol-placement': 'line',
                'text-font': ['Noto Sans Regular'],
                'text-field': ['get', 'name'],
                'text-size': 12,
            },
            'paint': {
                'text-color': '#91888b',
                'text-halo-color': '#ffffff',
                'text-halo-width': 2,
            },
        },
        {
            'id': 'physical_point_ocean',
            'type': 'symbol',
            'source': 'protomaps',
            'source-layer': 'physical_point',
            'filter': [
                'any',
                [
                    'in',
                    'pmap:kind',
                    'sea',
                    'ocean',
                    'lake',
                    'water',
                    'bay',
                    'strait',
                    'fjord',
                ],
            ],
            'layout': {
                'text-font': ['Noto Sans Medium'],
                'text-field': ['get', 'name'],
                'text-size': [
                    'interpolate',
                    ['linear'],
                    ['zoom'],
                    3,
                    10,
                    10,
                    12,
                ],
                'text-letter-spacing': 0.1,
                'text-max-width': 9,
                'text-transform': 'uppercase',
            },
            'paint': {
                'text-color': '#ffffff',
            },
        },
        {
            'id': 'physical_point_lakes',
            'type': 'symbol',
            'source': 'protomaps',
            'source-layer': 'physical_point',
            'filter': ['any', ['in', 'pmap:kind', 'lake', 'water']],
            'layout': {
                'text-font': ['Noto Sans Medium'],
                'text-field': ['get', 'name'],
                'text-size': [
                    'interpolate',
                    ['linear'],
                    ['zoom'],
                    3,
                    0,
                    6,
                    12,
                    10,
                    12,
                ],
                'text-letter-spacing': 0.1,
                'text-max-width': 9,
            },
            'paint': {
                'text-color': '#ffffff',
            },
        },
        {
            'id': 'roads_labels_major',
            'type': 'symbol',
            'source': 'protomaps',
            'source-layer': 'roads',
            'minzoom': 11,
            'filter': [
                'any',
                ['in', 'pmap:kind', 'highway', 'major_road', 'medium_road'],
            ],
            'layout': {
                'symbol-sort-key': ['get', 'pmap:min_zoom'],
                'symbol-placement': 'line',
                'text-font': ['Noto Sans Regular'],
                'text-field': ['get', 'name'],
                'text-size': 12,
            },
            'paint': {
                'text-color': '#938a8d',
                'text-halo-color': '#ffffff',
                'text-halo-width': 2,
            },
        },
        {
            'id': 'places_subplace',
            'type': 'symbol',
            'source': 'protomaps',
            'source-layer': 'places',
            'filter': ['==', 'pmap:kind', 'neighbourhood'],
            'layout': {
                'symbol-sort-key': ['get', 'pmap:min_zoom'],
                'text-field': '{name}',
                'text-font': ['Noto Sans Regular'],
                'text-max-width': 7,
                'text-letter-spacing': 0.1,
                'text-padding': [
                    'interpolate',
                    ['linear'],
                    ['zoom'],
                    5,
                    2,
                    8,
                    4,
                    12,
                    18,
                    15,
                    20,
                ],
                'text-size': [
                    'interpolate',
                    ['exponential', 1.2],
                    ['zoom'],
                    11,
                    8,
                    14,
                    14,
                    18,
                    24,
                ],
                'text-transform': 'uppercase',
            },
            'paint': {
                'text-color': '#8f8f8f',
                'text-halo-color': '#e0e0e0',
                'text-halo-width': 2,
            },
        },
        {
            'id': 'pois_important',
            'type': 'symbol',
            'source': 'protomaps',
            'source-layer': 'pois',
            'filter': ['any', ['<', ['get', 'pmap:min_zoom'], 13]],
            'layout': {
                'symbol-sort-key': ['get', 'pmap:min_zoom'],
                'text-font': ['Noto Sans Regular'],
                'text-field': ['get', 'name'],
                'text-size': 11,
                'text-max-width': 9,
                'icon-padding': [
                    'interpolate',
                    ['linear'],
                    ['zoom'],
                    0,
                    2,
                    14,
                    2,
                    16,
                    20,
                    17,
                    2,
                    22,
                    2,
                ],
            },
            'paint': {
                'text-color': '#8f8f8f',
                'text-halo-color': '#e0e0e0',
                'text-halo-width': 1.5,
            },
        },
        {
            'id': 'housenumbers',
            'type': 'symbol',
            'source': 'protomaps',
            'source-layer': 'housenumbers',
            'layout': {
                'text-font': ['Noto Sans Regular'],
                'text-field': ['get', 'addr:housenumber'],
                'text-size': 11,
                'text-max-width': 9,
            },
            'paint': {
                'text-color': '#8f8f8f',
                'text-halo-color': '#e0e0e0',
                'text-halo-width': 1.5,
            },
        },
        {
            'id': 'places_locality_circle',
            'type': 'circle',
            'source': 'protomaps',
            'source-layer': 'places',
            'filter': ['==', 'pmap:kind', 'locality'],
            'paint': {
                'circle-radius': 2,
                'circle-stroke-width': 1.5,
                'circle-stroke-color': '#a3a3a3',
                'circle-color': '#ffffff',
                'circle-translate': [-6, 0],
            },
            'maxzoom': 8,
        },
        {
            'id': 'places_locality',
            'type': 'symbol',
            'source': 'protomaps',
            'source-layer': 'places',
            'filter': ['==', 'pmap:kind', 'locality'],
            'layout': {
                'text-field': '{name}',
                'text-font': [
                    'case',
                    ['<=', ['get', 'pmap:min_zoom'], 5],
                    ['literal', ['Noto Sans Medium']],
                    ['literal', ['Noto Sans Regular']],
                ],
                'text-padding': [
                    'interpolate',
                    ['linear'],
                    ['zoom'],
                    5,
                    3,
                    8,
                    7,
                    12,
                    11,
                ],
                'text-size': [
                    'interpolate',
                    ['linear'],
                    ['zoom'],
                    2,
                    [
                        'case',
                        ['<', ['get', 'pmap:population_rank'], 13],
                        8,
                        ['>=', ['get', 'pmap:population_rank'], 13],
                        13,
                        0,
                    ],
                    4,
                    [
                        'case',
                        ['<', ['get', 'pmap:population_rank'], 13],
                        10,
                        ['>=', ['get', 'pmap:population_rank'], 13],
                        15,
                        0,
                    ],
                    6,
                    [
                        'case',
                        ['<', ['get', 'pmap:population_rank'], 12],
                        11,
                        ['>=', ['get', 'pmap:population_rank'], 12],
                        17,
                        0,
                    ],
                    8,
                    [
                        'case',
                        ['<', ['get', 'pmap:population_rank'], 11],
                        11,
                        ['>=', ['get', 'pmap:population_rank'], 11],
                        18,
                        0,
                    ],
                    10,
                    [
                        'case',
                        ['<', ['get', 'pmap:population_rank'], 9],
                        12,
                        ['>=', ['get', 'pmap:population_rank'], 9],
                        20,
                        0,
                    ],
                    15,
                    [
                        'case',
                        ['<', ['get', 'pmap:population_rank'], 8],
                        12,
                        ['>=', ['get', 'pmap:population_rank'], 8],
                        22,
                        0,
                    ],
                ],
                'icon-padding': [
                    'interpolate',
                    ['linear'],
                    ['zoom'],
                    0,
                    2,
                    8,
                    4,
                    10,
                    8,
                    12,
                    6,
                    22,
                    2,
                ],
                'text-anchor': ['step', ['zoom'], 'left', 8, 'center'],
                'text-radial-offset': 0.2,
            },
            'paint': {
                'text-color': '#5c5c5c',
                'text-halo-color': '#e0e0e0',
                'text-halo-width': 1,
            },
        },
        {
            'id': 'places_region',
            'type': 'symbol',
            'source': 'protomaps',
            'source-layer': 'places',
            'filter': ['==', 'pmap:kind', 'region'],
            'layout': {
                'symbol-sort-key': ['get', 'pmap:min_zoom'],
                'text-field': [
                    'step',
                    ['zoom'],
                    ['get', 'name:short'],
                    6,
                    ['get', 'name'],
                ],
                'text-font': ['Noto Sans Regular'],
                'text-size': [
                    'interpolate',
                    ['linear'],
                    ['zoom'],
                    3,
                    11,
                    7,
                    16,
                ],
                'text-radial-offset': 0.2,
                'text-anchor': 'center',
                'text-transform': 'uppercase',
            },
            'paint': {
                'text-color': '#b3b3b3',
                'text-halo-color': '#e0e0e0',
                'text-halo-width': 2,
            },
        },
        {
            'id': 'places_country',
            'type': 'symbol',
            'source': 'protomaps',
            'source-layer': 'places',
            'filter': ['==', 'pmap:kind', 'country'],
            'layout': {
                'symbol-sort-key': ['get', 'pmap:min_zoom'],
                'text-field': '{name}',
                'text-font': ['Noto Sans Medium'],
                'text-size': [
                    'interpolate',
                    ['linear'],
                    ['zoom'],
                    2,
                    [
                        'case',
                        ['<', ['get', 'pmap:population_rank'], 10],
                        8,
                        ['>=', ['get', 'pmap:population_rank'], 10],
                        12,
                        0,
                    ],
                    6,
                    [
                        'case',
                        ['<', ['get', 'pmap:population_rank'], 8],
                        10,
                        ['>=', ['get', 'pmap:population_rank'], 8],
                        18,
                        0,
                    ],
                    8,
                    [
                        'case',
                        ['<', ['get', 'pmap:population_rank'], 7],
                        11,
                        ['>=', ['get', 'pmap:population_rank'], 7],
                        20,
                        0,
                    ],
                ],
                'icon-padding': [
                    'interpolate',
                    ['linear'],
                    ['zoom'],
                    0,
                    2,
                    14,
                    2,
                    16,
                    20,
                    17,
                    2,
                    22,
                    2,
                ],
                'text-transform': 'uppercase',
            },
            'paint': {
                'text-color': '#a3a3a3',
            },
        },
        {
            'id': 'building',
            'type': 'fill',
            'source': 'protomaps',
            'source-layer': 'buildings',
            'metadata': {},
            'minzoom': 13,
            'maxzoom': 14,
            'layout': {
                visibility: 'visible',
            },
            'paint': {
                'fill-color': 'rgba(189, 185, 181, 0.3)',
                'fill-outline-color': {
                    base: 1,
                    stops: [
                        [13, 'hsla(35, 6%, 79%, 0.32)'],
                        [14, 'hsl(35, 6%, 79%)'],
                    ],
                },
            },
        },
        {
            'id': 'building-3d',
            'type': 'fill-extrusion',
            'source': 'protomaps',
            'source-layer': 'buildings',
            'metadata': {},
            'minzoom': 14,
            'filter': ['all', ['!has', 'hide_3d']],
            'layout': {
                visibility: 'visible',
            },
            'paint': {
                'fill-extrusion-base': {
                    type: 'identity',
                    property: 'min_height',
                },
                'fill-extrusion-color': [
                    'case',
                    ['has', 'height'],
                    [
                        'interpolate',
                        ['linear'],
                        ['get', 'height'],
                        0,
                        'lightgray',
                        20,
                        'gray',
                        50,
                        'royalblue',
                    ],
                    'lightgray',
                ],
                'fill-extrusion-height': [
                    'case',
                    ['has', 'height'],
                    ['get', 'height'],
                    10,
                ],
                'fill-extrusion-opacity': 0.7,
            },
        },
    ],
    glyphs: 'https://protomaps.github.io/basemaps-assets/fonts/{fontstack}/{range}.pbf',
};
export const baseStyle = baseStyleRaw;
//# sourceMappingURL=data:application/json;base64,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